import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { MessageService } from '../message.service';
import { Subscription } from 'rxjs';
import { RestApiService } from '../rest-api.service';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { NotifierService } from 'angular-notifier';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { SocketService } from '../socket.service';

// import { ChartComponent } from '../chart/chart.component';

@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit, OnDestroy {
    isCollapsed: boolean;
    // clientId: number;
    clientName: string;
    userGroups: any;
    userGroupId: number;
    groupName: string;
    grpLevel: number;
    respObject: any;
    tilesData = [];
    isLabel0: boolean;
    isLabel1: boolean;
    isLabel2: boolean;
    islead: boolean;
    cat1: any;
    cat2: any;
    cat3: any;
    cat4: any;
    private userAuth: Subscription;
    private ticketSub: Subscription;
    userGroupSelected: number;
    private ticketType: number;
    ticketTypeLoaded = false;
    radioButton = [];
    selectedData = [];
    private notifier: NotifierService;
    hideChart: boolean;
    modal: any;
    radius: number;
    clientId: number;
    categories = [];
    categorySelected: number;
    errorMessage: string;
    isError = false;
    users = [];
    userSelected: number;
    @ViewChild('content') content;
    private dashboardSubscribe: Subscription;
    isLoading: boolean;
    typeSeq: number;
    cat2Alt: string;
    
    constructor(private messageService: MessageService, private _rest: RestApiService,
        private actRoute: ActivatedRoute, private route: Router, notifier: NotifierService,
        private modalService: NgbModal, private socketService: SocketService) {
        this.notifier = notifier;
        this.dashboardSubscribe = this.socketService.dashboardSubject.subscribe((data) => {
            console.log('-->: ' + JSON.stringify(data));
            if (this.userGroupId === data.groupId) {
                console.log('-->: inside ');
                const menuId = data.menuId;
                const displayelem = document.getElementById('display_' + menuId);
                if (displayelem !== undefined && displayelem !== null) {
                    displayelem.classList.remove('none');
                }
                const countelem = document.getElementById('count_' + menuId);
                if (countelem !== undefined && countelem !== null) {
                    countelem.innerText = (Number(countelem.innerText) + 1) + '';
                }
            }
        });
    }

    ngOnInit() {
        this.isLoading = false;
        this.radius = 65;
        this.isLabel0 = false;
        this.isLabel1 = false;
        this.isLabel2 = false;
        this.islead = false;
        this.hideChart = true;
        this.categorySelected = 0;
        this.userSelected = 0;
        this.actRoute.queryParams.subscribe(params => {
            const token = params['token'];
            this.clientId = params['clientId'];
            const encodedUserName = params['name'];
            let userName;
            if (encodedUserName) {
                userName = this.messageService.xorEncode(atob(encodedUserName), this.messageService.SECRET_TOKEN);
            }
            this.cat1 = params['cat1'];
            this.cat2 = params['cat2'];
            const sourceType = params['srcType'];
            const ticketType1 = params['ticket_type1'];
            const ticketType2 = params['ticket_type2'];
            this.cat3 = params['cat3'];
            this.cat4 = params['cat4'];
            this.cat2Alt = params['cat2Alt'];

            let callback = params['callback'];
            let count = 0;
            let isIncident = false;
            let isProblem = false;
            this.messageService.setClientId(this.clientId);
            // // console.log(ticketType1, typeof ticketType1);
            if (this.clientId !== undefined && token !== undefined && userName !== undefined) {
                // // console.log('from panel');
                if (callback === 'undefined' || callback === undefined || callback === '') {
                    callback = this.messageService.API_ROOT;
                }
                if (sourceType !== 'undefined' && sourceType !== undefined && sourceType !== '') {
                    this.messageService.saveSourceType(sourceType);
                }
                if (ticketType1 !== 'undefined' && ticketType1 !== undefined && ticketType1 !== '') {
                    if (this.cat1 === 'undefined' || this.cat1 === undefined || this.cat1 === '') {
                        alert(this.messageService.CATEGORY1_ERROR);
                        window.location.href = callback;
                    }
                    if (this.cat2 === 'undefined' || this.cat2 === undefined || this.cat2 === '') {
                        alert(this.messageService.CATEGORY2_ERROR);
                        window.location.href = callback;
                    }
                    // if (this.cat2Alt === 'undefined' || this.cat2Alt === undefined || this.cat2Alt === '') {
                    //     alert(this.messageService.CATEGORY2_ERROR);
                    //     window.location.href = callback;
                    // }

                    isIncident = true;
                    count++;
                }
                if (ticketType2 !== 'undefined' && ticketType2 !== undefined && ticketType2 !== '') {
                    if (this.cat3 === 'undefined' || this.cat3 === undefined || this.cat3 === '') {
                        alert(this.messageService.CATEGORY1_ERROR);
                        window.location.href = callback;
                    }
                    if (this.cat4 === 'undefined' || this.cat4 === undefined || this.cat4 === '') {
                        alert(this.messageService.CATEGORY2_ERROR);
                        window.location.href = callback;
                    }
                    isProblem = true;
                    count++;
                }
                if (count === 0) {
                    alert(this.messageService.NO_TICKET_TYPE);
                    window.location.href = callback;
                } else {
                    this.messageService.clearSession();
                    if (isIncident) {
                        // this.messageService.saveCategory1({ cat1: this.cat1, cat2: this.cat2, cat2Alt: this.cat2Alt });
                        this.messageService.saveCategory1({ cat1: this.cat1, cat2: this.cat2 });
                    }
                    if (isProblem) {
                        this.messageService.saveCategory2({ cat1: this.cat3, cat2: this.cat4 });
                    }

                    const data = { clientId: this.clientId, token: token, loginName: userName };

                    this._rest.tokenValidation(data).subscribe((res) => {
                        this.respObject = res;
                        if (this.respObject.success) {
                            // sessionStorage.setItem('id', this.respObject.details);
                            // sessionStorage.setItem('data', token);
                            this.messageService.addSessionData(this.respObject.details, token, this.clientId);
                            this.messageService.tokenSubject.next();
                            sessionStorage.removeItem('dd');
                            this.userAuth = this.messageService.getClientUserAuth().subscribe(auth => {
                                this.clientName = auth[0].client;
                                this.userGroups = auth[0].groupId;
                                // console.log(this.messageService.getSupportGroup());
                                // if (this.messageService.getSupportGroup() === null) {
                                if (this.userGroups !== undefined) {
                                    this.userGroupId = this.userGroups[0].groupId;
                                    this.groupName = this.userGroups[0].grpName;
                                    this.grpLevel = this.userGroups[0].level;
                                }
                                // } else {
                                //     const group = this.messageService.getSupportGroup();
                                //     this.userGroupId = group.groupId;
                                //     this.groupName = group.grpName;
                                //     this.grpLevel = group.level;
                                // }
                                this.userGroupSelected = this.userGroupId;
                                // this.name = userName;
                                // console.log('-----token validation-------');
                                this.onPageLoad();
                                // }
                            });
                            // this.onPageLoad();
                        } else {
                            this.messageService.clearSession();
                            alert(this.messageService.URL_TOKEN_ERROR1);
                            window.location.href = callback;
                            // console.log(this.respObject.errorMessage);
                        }
                    }, (err) => {
                        this.messageService.clearSession();
                        alert(this.messageService.TOKEN_TIMEOUT_ERROR);
                        window.location.href = callback;
                    });
                }
            } else {
                if (this.messageService.getUserId() === null || this.messageService.getToken() === null) {
                    this.messageService.clearSession();
                    window.location.href = this.messageService.API_ROOT;
                } else {
                    // this.sourceType = 'web';
                    if (this.messageService.clientId) {
                        this.clientId = this.messageService.clientId;
                        this.clientName = this.messageService.client;
                        this.userGroups = this.messageService.groupId;
                        this.messageService.setClientId(this.clientId);
                        if (this.userGroups !== undefined) {
                            if (this.messageService.getSupportGroup() === null) {
                                this.userGroupId = this.userGroups[0].groupId;
                                this.groupName = this.userGroups[0].grpName;
                                this.grpLevel = this.userGroups[0].level;
                            } else {
                                const group = this.messageService.getSupportGroup();
                                this.userGroupId = group.groupId;
                                this.groupName = group.grpName;
                                this.grpLevel = group.level;
                            }
                            this.userGroupSelected = this.userGroupId;
                        }
                        // console.log('-----within page-------');
                        this.onPageLoad();
                    } else {
                        this.userAuth = this.messageService.getClientUserAuth().subscribe(auth => {
                            this.clientId = auth[0].clientId;
                            this.clientName = auth[0].client;
                            this.userGroups = auth[0].groupId;
                            this.messageService.setClientId(this.clientId);
                            if (this.userGroups !== undefined) {
                                if (this.messageService.getSupportGroup() === null) {
                                    this.userGroupId = this.userGroups[0].groupId;
                                    this.groupName = this.userGroups[0].grpName;
                                    this.grpLevel = this.userGroups[0].level;
                                } else {
                                    const group = this.messageService.getSupportGroup();
                                    this.userGroupId = group.groupId;
                                    this.groupName = group.grpName;
                                    this.grpLevel = group.level;
                                }
                                this.userGroupSelected = this.userGroupId;
                            }
                            // console.log('-----page refresh-------');
                            this.onPageLoad();
                            // }
                        });
                    }
                }
            }
        });
        // -------------------------------------------------
        // window.addEventListener('click', function (event) {
        //     // console.log('AAAAAAAAAAAA==========', this.modal.close());
        // });
    }

    onPageLoad() {
        // console.log(' ---- log -------');
        // const ticketType = 32;
        // // console.log('group level===============', this.grpLevel, this.ticketType;
        this.isLoading = true;
        this.tilesData = [];
        if (this.userGroupId) {
            this.ticketSub = this._rest.getTicketTypeForTicketCreation_LNT(this.clientId, this.userGroupId).subscribe((res1) => {
                this.respObject = res1;
                this.ticketTypeLoaded = true;
                if (this.respObject.success) {
                    this.radioButton = this.respObject.details;
                    const storage = JSON.parse(sessionStorage.getItem('dd'));
                    if (storage === null) {
                        this.categorySelected = 0;
                        this.userSelected = 0;
                        this.ticketType = this.radioButton[0].id;
                        this.typeSeq = this.radioButton[0].seq;
                    } else {
                        const type = storage.type;
                        this.radioButton[0].checked = false;
                        for (let i = 0; i < this.radioButton.length; i++) {
                            // console.log(this.types[i].id, type);
                            if (this.radioButton[i].id === type) {
                                this.ticketType = this.radioButton[i].id;
                                this.radioButton[i].checked = true;
                                this.typeSeq = this.radioButton[i].seq;
                                break;
                            }
                        }
                        this.categorySelected = storage.cat;
                        this.userSelected = storage.user;
                    }
                    this._rest.checkIsLead(this.clientId, this.userGroupId, this.messageService.getUserId()).subscribe((res3) => {
                        this.respObject = res3;
                        if (this.respObject.success) {
                            this.islead = this.respObject.details[0].is_spoc;
                            // // console.log('this.islead:' + this.islead);

                            // ========================================================
                            if ((this.grpLevel === 1 && this.islead) || this.grpLevel >= 2) {
                                this._rest.getCategoryListSupportGroupWise(this.userGroupId, this.clientId,
                                    this.ticketType).subscribe((res4) => {
                                        this.respObject = res4;
                                        if (this.respObject.success) {
                                            this.respObject.details.unshift({ id: 0, name: 'Select Category' });
                                            this.categories = this.respObject.details;
                                        } else {
                                            this.notifier.notify('error', this.respObject.errorMessage);
                                        }
                                    }, (err) => {
                                        // this.isError = true;
                                        // this.errorMessage = this.messageService.SERVER_ERROR;
                                    });
                            }
                            if (this.grpLevel === 1 && this.islead) {
                                this._rest.getAllLevelOneUser(this.clientId).subscribe((res5) => {
                                    this.respObject = res5;
                                    if (this.respObject.success) {
                                        this.isError = false;
                                        // // console.log(this.respObject);
                                        this.respObject.details.unshift({ id: 0, name: 'Select Analyst' });
                                        this.users = this.respObject.details;
                                        // this.userSelected = 0;
                                    } else {
                                        this.notifier.notify('error', this.respObject.errorMessage);
                                    }
                                }, (err) => {
                                    // this.isError = true;
                                    // this.errorMessage = this.messageService.SERVER_ERROR;
                                });
                            }
                            // ==========================================================
                            // end user and l1 => dash bord detls
                            //   l1 lead => getDashBoardDtlsForTeamLead
                            //   l2 -l5 new api => getDashBoardDtlsForLeader
                            this.getDynamicMenu_new();
                        } else {

                        }
                    });

                } else {
                    this.isLoading = false;
                }
            });
        } else {
            this.ticketTypeLoaded = true;
            this.isLoading = false;
        }
        if (this.grpLevel === 0) {
            this.isLabel0 = true;
        } else if (this.grpLevel === 1) {
            this.isLabel1 = true;
        } else if (this.grpLevel >= 2) {
            this.isLabel2 = true;
        }
    }

    getDynamicMenu_new() {
        this.isLoading = true;
        this._rest.getDynamicMenuTicketTypeWise(this.clientId, this.ticketType,
            this.messageService.getUserId(), 1, this.userGroupId).subscribe((res2) => {
                this.respObject = res2;
                // // console.log(JSON.stringify(this.respObject));
                if (this.respObject.success) {
                    this.tilesData = [];
                    this.selectedData = this.respObject.details;
                    this.isLoading = false;
                    this.tilesData = this.selectedData;
                    for (let i = 0; i < this.selectedData.length; i++) {
                        // this._rest.getDashBoardDtls_new(this.clientId, this.userGroupId, this.ticketType,
                        this._rest.getDynamicTotCountMenuTicketDtls_new(this.clientId, this.userGroupId, this.ticketType, this.typeSeq,
                            this.selectedData[i].fid, this.categorySelected, this.userSelected).subscribe((res) => {
                                this.respObject = res;
                                // // console.log('data--Done=======', this.respObject);
                                if (this.respObject.success) {
                                    document.getElementById('loader_' + this.respObject.details[0].id).hidden = true;
                                    document.getElementById('count_' + this.respObject.details[0].id).innerText = this.respObject.details[0].value;
                                } else {
                                    this.notifier.notify('error', this.respObject.errorMessage);
                                }
                            }, (err) => {
                            });
                    }
                    this._rest.checkOfflineDashNotification(this.clientId, this.userGroupId,
                        this.messageService.getUserId(), this.ticketType, 1).subscribe((res) => {
                            this.respObject = res;
                            if (this.respObject.success) {
                                const result = this.respObject.details;
                                // this.menus = this.respObject.details;
                                for (let i = 0; i < result.length; i++) {
                                    const menuId = result[i].noti_type;
                                    const displayelem = document.getElementById('display_' + menuId);
                                    if (displayelem !== undefined && displayelem !== null) {
                                        displayelem.classList.remove('none');
                                    }

                                }
                            }
                        });
                } else {
                    this.notifier.notify('error', this.respObject.errorMessage);
                }
            }, (err) => {
                // this.notifier.notify('error', this.messageService.SERVER_ERROR);
            });
    }

    createTicket() {
        sessionStorage.setItem('dd', JSON.stringify({
            type: this.ticketType,
            seq: this.typeSeq,
            user: this.userSelected,
            cat: this.categorySelected
        }));
        // this.route.navigate(['ticket/createTicketL&T']);
        if (this.messageService.createUrl !== undefined && this.messageService.createUrl !== null) {
            this.messageService.changeRouting(this.messageService.createUrl);
        }
    }

    onButtonChange(selectedButton) {
        // // console.log('+++++++++++++++++', selectedButton, selectedButton.value.id)
        this.ticketType = selectedButton.value.id;
        this.typeSeq = selectedButton.value.seq;
        this.messageService.saveMenuData({
            type: this.ticketType,
            seq: this.typeSeq,
            user: this.userSelected,
            cat: this.categorySelected
        });
        this.getDynamicMenu_new();
    }

    goto(fid) {
        // // console.log('**********************', fid);

        sessionStorage.setItem('dd', JSON.stringify({
            id: fid,
            type: this.ticketType,
            seq: this.typeSeq,
            user: this.userSelected,
            cat: this.categorySelected
        }));
        if (this.messageService.viewUrl !== undefined && this.messageService.viewUrl !== null) {
            this.messageService.changeRouting(this.messageService.viewUrl);
        }
        // this.route.navigate(['ticket/viewTicketL&TSSC']);
    }

    onSelectGroup() {
        this.isLabel0 = false;
        this.isLabel1 = false;
        this.isLabel2 = false;
        this.islead = false;
        if (this.userGroupSelected !== 0) {
            this.userGroupId = this.userGroupSelected;
            for (let i = 0; i < this.userGroups.length; i++) {
                if (this.userGroups[i].groupId === this.userGroupId) {
                    this.groupName = this.userGroups[i].grpName;
                    this.grpLevel = this.userGroups[i].level;
                }
            }
            if (this.grpLevel === 0) {
                this.isLabel0 = true;
            } else if (this.grpLevel === 1) {
                this.isLabel1 = true;
            } else if (this.grpLevel >= 2) {
                this.isLabel2 = true;
            }
            this.messageService.saveSupportGroup({
                groupId: this.userGroupId,
                grpName: this.groupName,
                level: this.grpLevel
            });

            // console.log('-----change group-------');
            this.onPageLoad();
        }
    }

    onSelectCategory() {
        this.userSelected = 0;
        this.getDynamicMenu_new();
    }

    onSelectUser() {
        this.categorySelected = 0;
        this.getDynamicMenu_new();
    }

    chartDetails() {
        // this.modalService.open(ChartComponent, {size: 'lg'});
        this.hideChart = false;
        // this.radius = 65;
        const modal = this.modalService.open(this.content);
        modal.result.then(() => {
            // console.log('When user closes');
        }, () => {
            // console.log('Backdrop click');
            this.hideChart = true;
        });
    }

    ngOnDestroy() {
        if (this.userAuth) {
            this.userAuth.unsubscribe();
        }

        if (this.ticketSub) {
            this.ticketSub.unsubscribe();
        }
        if (this.dashboardSubscribe) {
            this.dashboardSubscribe.unsubscribe();
        }
    }

    goTofaq() {
        // this.route.navigate(['ticket/faq']);
        if (this.messageService.faqUrl !== undefined && this.messageService.faqUrl !== null) {
            this.messageService.changeRouting(this.messageService.faqUrl);
        }
    }
    goToBulkAssigment(){
        // console.log('hi im in bulk assignment');
        if (this.messageService.bulkAssigmentUrl !== undefined && this.messageService.bulkAssigmentUrl !== null) {
            this.messageService.changeRouting(this.messageService.bulkAssigmentUrl);
        }
        // this.route.navigate(['ticket/bulkAssigment']);

        
    }
    goToSearch() {
        sessionStorage.setItem('dd', JSON.stringify({
            type: this.ticketType,
            seq: this.typeSeq,
            user: this.userSelected,
            cat: this.categorySelected
        }));
        // this.route.navigate(['ticket/search']);
        if (this.messageService.searchUrl !== undefined && this.messageService.searchUrl !== null) {
            this.messageService.changeRouting(this.messageService.searchUrl);
        }
    }

}

